import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppNavigation } from 'src/routes';
import { useAuth } from '../contexts/AuthContext';
import { useAuth0 } from '@auth0/auth0-react';
import SuspenseLoader from './SuspenseLoader';
import { useGetConfig, useGetConfigAuth } from 'src/hooks/api/useConfigEndpoint';

interface ProtectedRoutesProps {
  requiredPermissions?: string[];
  children?: React.ReactNode;
}

export const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({ requiredPermissions, children }) => {
  const location = useLocation();
  const { permissions, isAuthenticated } = useAuth();
  const { isLoading, isAuthenticated: auth0IsAuthenticated } = useAuth0();
  const { routesMap } = useAppNavigation();
  const { data: configAuthData } = useGetConfigAuth();
  useGetConfig();

  if (isLoading) {
    return <SuspenseLoader />;
  }

  if (isAuthenticated) {
    if (requiredPermissions) {
      if (!requiredPermissions.some((permission) => permissions?.includes(permission))) {
        return <Navigate to={routesMap.noPermission} replace state={{ from: location }} />;
      }
    }

    return children ? <>{children}</> : <Outlet />;
  }

  if (!auth0IsAuthenticated && configAuthData?.platform === 'Auth0') {
    return <Navigate to={routesMap.auth0Callback} replace state={{ from: location }} />;
  }

  if (!isAuthenticated && configAuthData?.platform !== 'Auth0') {
    return <Navigate to={routesMap.login} replace state={{ from: location }} />;
  }
};
